import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { IPlacementTest } from 'src/app/interfaces/resource';
import { DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ConvertService, pushObjArray } from 'src/app/services/convert.service';
import { PlacementTest } from 'src/app/stores/testingCenter/placementTest.store';

@Component({
  selector: 'app-add-placement-vocabulary-question',
  templateUrl: './add-placement-vocabulary-question.component.html',
  styleUrls: ['./add-placement-vocabulary-question.component.scss']
})
export class AddPlacementVocabularyQuestionComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  form: FormGroup;
  question: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;
  TITLE = 'Add new question';

  constructor(
    public dialogRef: MatDialogRef<AddPlacementVocabularyQuestionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: PlacementTest,
    private snackBar: MatSnackBar,
    private ds: DataService,
    private route: Router,
  ) { }

  ngOnInit() {
    const { QUESTION } = this.data;
    this.form = this.fb.group({
      question: [QUESTION ? QUESTION.name : null, Validators.compose([Validators.required])],
    })
    this.question = this.form.controls['question'];

    if (QUESTION) {
      this.TITLE = "Edit question";
    }
  }


  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    this.isCreate = true;
    if (this.form.valid) {
      this.form.disable();
      const { question } = f;
      const { FORM, ITEM, QUESTION, TYPE_KEY, QUESTION_KEY } = this.data;
      const { name } = FORM;
      const { user, selectedCompanyKey } = this.auth;
      const questions = ITEM ? ITEM.questions : []

      const BLOCK_DATA = QUESTION ? QUESTION.name === `${question}`.trim() ? QUESTION.block : [] : []
      const row = { key: QUESTION ? QUESTION.key : this.ds.createId(), name: `${question}`.trim(), block: BLOCK_DATA };
      const QUESTION_DATA = pushObjArray(questions, row)

      const registerStatus = STATUS_OBJECT.submitted;
      const activity: IPlacementTest = {
        key: ITEM ? ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: ITEM ? ITEM.created_at : new Date(),
        created_by: ITEM ? ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: null,
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: selectedCompanyKey,
        created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        tip: name || null,
        questions: QUESTION_DATA,
        skillKey: 'vocabulary',
        testingTypeKey: TYPE_KEY
      }
      this.store.addItem(activity, (success, res) => {
        this.data.ITEM = activity;
        this.snackBar.open("Question has been saved successful.", "Done", { duration: 1000 });
        if (!isNew) {
          this.dialogRef.close('no')
          this.route.navigate([`/testing-center/placement-test/vocabulary/vocabulary_pi/${activity.key}`])
          return;
        }
        this.form.reset();
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.isCreate = false;
        this.route.navigate([`/testing-center/placement-test/vocabulary/vocabulary_pi/${activity.key}`])
      })
    }
    else {
      this.processNew = false;
      this.processClose = false;
      this.isCreate = false;
    }
  }
}